/* ==========================================================================
   menu-drawer.js — MENU TIROIR (portable / petits écrans) — For.me
   --------------------------------------------------------------------------
   À CHARGER dans theme.liquid (après les autres fichiers custom) :
     <script src="{{ 'menu-drawer.js' | asset_url }}" defer></script>

   Rôle :
   - détecter OUVERTURE / FERMETURE du tiroir (.menu-drawer) via sa présence à
     l'écran (offsetWidth).
   - à l'ouverture :
       * mesurer la BARRE du header (en EXCLUANT le drawer) et poser le panneau
         juste dessous, un peu moins large, centré, avec un léger tuck derrière
       * mettre SEULEMENT la barre/host du header au-dessus (jamais le drawer)
       * reveal haut->bas, hauteur = contenu (plafonnée), jamais plein écran
   - à la fermeture : tout restaurer.

   ⚠️ Corrections v4 :
   - le repérage de la barre du header EXCLUT le drawer et ses descendants
     (sinon le drawer se prenait pour le header : bugs "au milieu" / "header caché")
   - on ne touche JAMAIS au position/z-index du drawer via le code header.
   ========================================================================== */
(function () {
  'use strict';

  var DRAWER_SELECTOR = '.menu-drawer, [ref="menuDrawer"]';
  var DRAWER_Z = 2147483000;
  var HEADER_Z = 2147483600;   // strictement au-dessus du panneau
  var DRAWER_BODY_Z = 17;      // z-index du panneau une fois sorti dans <body> :
                               // JUSTE SOUS la section header (z:18), AU-DESSUS de la page
  var MAX_VH = 0.72;           // hauteur max = 72% de l'écran
  var MAX_W  = 720;            // largeur max du panneau, en px. Sans plafond,
                               // il s'étirait sur toute la page et laissait
                               // les deux tiers vides sur iPad. Toujours
                               // CENTRÉ, quelle que soit la largeur.
  var TUCK = 25;               // chevauchement vers le HAUT : le bord sup. du drawer
                               // passe SOUS le header (la section header, z:18, le recouvre).
                               // + petit = drawer un peu PLUS BAS

  /* PLUS DE BORNE DE LARGEUR — pendant du changement fait dans
     menu-drawer.css. Ce test coupait le portail et le plafond de hauteur
     au-delà d'une largeur donnée : le même bouton burger ouvrait donc un
     panneau placé et dimensionné sur petit écran, et le panneau natif du
     thème au-dessus. Sur iPad en paysage, on tombait sur le second.

     La largeur ne décide pas qu'un tiroir est visible : c'est le réglage
     du header. Ce code ne s'exécute de toute façon QUE sur l'ouverture
     d'un `.menu-drawer` — s'il n'y en a pas d'affiché, rien ne se
     déclenche. Le garde ne servait donc à rien, sauf à casser les grandes
     largeurs. */
  function isMobile() {
    return true;
  }
  function drawer() { return document.querySelector(DRAWER_SELECTOR); }

  /* PORTAL : à l'ouverture on SORT le panneau dans <body> pour qu'il ne soit plus
     un descendant du header. Imbriqué dans la pilule, il se peint TOUJOURS par-dessus
     le header (un enfant ne passe pas derrière le fond de son parent, quel que soit
     le z-index). Une fois dans <body>, un z-index < section header (18) le met
     VRAIMENT derrière le header. On mémorise sa place d'origine pour l'y remettre à
     la fermeture (sinon on casse la logique open/close du thème). */
  function portalToBody(el) {
    if (!el || el.__fmPortaled) return;
    el.__fmDetails = el.closest ? el.closest('details') : null;   // pour fermer + détecter la fermeture
    el.__fmHomeParent = el.parentNode;
    el.__fmHomeNext = el.nextSibling;
    el.__fmPortaled = true;
    document.body.appendChild(el);
  }
  function restoreHome(el) {
    if (!el || !el.__fmPortaled) return;
    var p = el.__fmHomeParent;
    if (p) {
      if (el.__fmHomeNext && el.__fmHomeNext.parentNode === p) p.insertBefore(el, el.__fmHomeNext);
      else p.appendChild(el);
    }
    el.__fmPortaled = false;
    delete el.__fmHomeParent; delete el.__fmHomeNext;
  }
  /* Sorti dans <body>, le panneau reste visible même fermé : sa visibilité ne dit
     plus s'il est ouvert. On lit l'état du <details> d'origine. */
  function portalOpen(el) {
    if (el.__fmDetails) return el.__fmDetails.hasAttribute('open');
    return document.querySelector('.menu-open') != null;
  }

  function isOpen(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    return el.offsetWidth > 10;
  }

  function headerHost() {
    return document.querySelector('#header-component') ||
           document.querySelector('.header') ||
           document.querySelector('header');
  }

  /* TENIR l'état "scrollé" du header (pilule glassmorphism, logo/texte foncés)
     pendant que le menu est ouvert.
     Problème : le module d'accueil de site-chrome.js remet data-sticky-state
     à l'état repos dès qu'on est en haut de page -> le header repassait en
     non-scrollé. Solution SANS boucle : on intercepte setAttribute/removeAttribute
     du header pour ignorer toute remise à zéro de data-sticky-state tant que le
     menu est ouvert, puis on restaure à la fermeture. */
  function holdSticky(on) {
    var h = document.querySelector('#header-component');
    if (!h) return;
    if (on) {
      if (h.__fmPrevSticky === undefined) h.__fmPrevSticky = h.getAttribute('data-sticky-state');
      if (!h.__fmSet) {
        h.__fmSet = h.setAttribute;
        h.__fmRem = h.removeAttribute;
        h.setAttribute = function (name, val) {
          if (name === 'data-sticky-state' && val !== 'active') return; // ignore les remises à zéro
          return h.__fmSet.call(h, name, val);
        };
        h.removeAttribute = function (name) {
          if (name === 'data-sticky-state') return;                    // idem
          return h.__fmRem.call(h, name);
        };
      }
      h.__fmSet.call(h, 'data-sticky-state', 'active');
      // Observer : certaines voies (dataset natif) contournent setAttribute.
      // On re-force 'active' à chaque changement. Pas de boucle : site-chrome.js
      // tente de revenir via setAttribute -> bloqué -> aucune mutation.
      if (!h.__fmStickyObs) {
        h.__fmStickyObs = new MutationObserver(function () {
          if (h.getAttribute('data-sticky-state') !== 'active') {
            h.__fmSet.call(h, 'data-sticky-state', 'active');
          }
        });
        h.__fmStickyObs.observe(h, { attributes: true, attributeFilter: ['data-sticky-state'] });
      }
    } else if (h.__fmSet) {
      if (h.__fmStickyObs) { h.__fmStickyObs.disconnect(); delete h.__fmStickyObs; }
      h.setAttribute = h.__fmSet;
      h.removeAttribute = h.__fmRem;
      delete h.__fmSet; delete h.__fmRem;
      // restaurer l'état d'origine (le module d'accueil reprend la main)
      if (h.__fmPrevSticky === null || h.__fmPrevSticky === undefined) h.removeAttribute('data-sticky-state');
      else h.setAttribute('data-sticky-state', h.__fmPrevSticky);
      delete h.__fmPrevSticky;
    }
  }

  /* Barre/pilule du header : élément COURT, en haut, avec un fond,
     en EXCLUANT le drawer et tout ce qu'il contient. */
  function headerBarEl(drawerEl) {
    var host = headerHost();
    if (!host) return null;
    var vw = window.innerWidth, best = null, bestArea = 0;
    var nodes = host.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      // EXCLURE le drawer et ses descendants (cause des bugs)
      if (drawerEl && (n === drawerEl || drawerEl.contains(n) || n.contains(drawerEl))) continue;
      if (n.closest && n.closest('.menu-drawer')) continue;
      var r = n.getBoundingClientRect();
      if (r.top > 200) continue;             // seulement tout en haut (annonce + header)
      if (r.height < 24 || r.height > 96) continue;  // une barre est COURTE
      if (r.width < vw * 0.45 || r.width > vw * 0.99) continue;
      var cs = getComputedStyle(n);
      var hasBg = (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent') ||
                  (cs.backdropFilter && cs.backdropFilter !== 'none') ||
                  (cs.webkitBackdropFilter && cs.webkitBackdropFilter !== 'none');
      if (!hasBg) continue;
      var area = r.width * r.height;
      if (area > bestArea) { bestArea = area; best = n; }
    }
    return best;
  }

  function headerRect(drawerEl) {
    var bar = headerBarEl(drawerEl);
    if (bar) return bar.getBoundingClientRect();
    var host = headerHost();
    return host ? host.getBoundingClientRect() : null;
  }

  /* Placer le panneau : TOUJOURS centré sur la PAGE (marges symétriques), juste
     sous le header. On ne le remonte PLUS derrière le header (ça teintait le
     header). Largeur = un peu moins que la page. */
  function positionUnderHeader(el) {
    var vw = window.innerWidth, vh = window.innerHeight;

    /* LARGEUR PLAFONNÉE, ET ALIGNÉE À GAUCHE QUAND ELLE L'EST.
       Avant : `vw - 64`, centré. Sur un téléphone ça donne un panneau qui
       occupe presque l'écran — c'est le dessin voulu. Sur un iPad en
       paysage, ça donnait 1100px de verre pour cinq entrées, avec les deux
       tiers vides à droite.

       Le plafond ne change que la largeur : le panneau reste CENTRÉ sur la
       page à toutes les tailles. En dessous du plafond — tous les
       téléphones — le calcul est exactement celui d'avant. */
    var pill = document.querySelector('#header-component .header__row--top');
    var width = Math.min(vw - 64, MAX_W);
    var left = Math.round((vw - width) / 2);     // centré page, à toute largeur

    // bas du header : on privilégie la PILULE (plus fiable que le conteneur qui
     // déborde vers le bas et créait le "détaché"). Borné pour rester collé.
    // Cible VIEWPORT : le panneau chevauche le bas du header (le header, au-dessus,
    // le recouvre). #header-component.bottom - 30 -> un cran SOUS la pilule.
    var host = headerHost();
    var hb = pill ? pill.getBoundingClientRect().bottom
                  : (host ? host.getBoundingClientRect().bottom : 150);
    var top = Math.max(PLANCHER_TOP, Math.min(Math.round(hb) - TUCK, PLAFOND_TOP));   // remonte de TUCK px -> le haut du drawer se glisse SOUS le header

    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('width', width + 'px', 'important');
    el.style.setProperty('left', left + 'px', 'important');
    el.style.setProperty('top', top + 'px', 'important');
    el.style.removeProperty('padding-top');      // revient au padding CSS

    // Le panneau peut atterrir ailleurs que là où on l'a envoyé : en
    // position:absolute sous un ancêtre décalé, et aussi en position:fixed sur
    // iOS, où le rect d'un élément fixe est décalé pendant que la barre d'URL se
    // rétracte — donc UNIQUEMENT quand la page a été scrollée.
    //
    // L'ancienne compensation corrigeait en UNE passe sans revérifier :
    //     el.style.top = top + (top - got.top)
    // Avec top = 50 et un rect mesuré à 98, elle écrivait 2 — sous le plancher
    // de 50 que la ligne du dessus venait d'imposer. Le panneau se collait en
    // haut de l'écran et recouvrait le header.
    //
    // On vise maintenant la position PEINTE et on la vérifie : chaque passe
    // mesure, calcule le reste à parcourir et n'écrit que ça. Deux passes
    // suffisent, et comme on relit après chaque écriture, on ne peut plus
    // dépasser la cible quelle que soit la raison du décalage.
    caler(el, top, left, vh, vw);

    // Filet : si malgré tout le bord haut peint se retrouve au-dessus du
    // plancher, on le ramène. Mieux vaut un panneau un cran trop bas qu'un
    // panneau qui mange le header.
    if (el.getBoundingClientRect().top < PLANCHER_TOP - 4) {
      caler(el, PLANCHER_TOP, left, vh, vw);
    }
  }

  var PLANCHER_TOP = 50;   // le haut du panneau ne monte jamais au-dessus
  var PLAFOND_TOP = 240;

  /* Amène le bord haut/gauche PEINT du panneau sur la cible viewport, en
     mesurant entre chaque correction. */
  function caler(el, topCible, leftCible, vh, vw) {
    for (var i = 0; i < 2; i++) {
      var r = el.getBoundingClientRect();
      var dt = topCible - r.top, dl = leftCible - r.left;
      var fini = true;
      if (Math.abs(dt) > 1 && Math.abs(dt) < vh) {
        el.style.setProperty('top', Math.round((parseFloat(el.style.top) || 0) + dt) + 'px', 'important');
        fini = false;
      }
      if (Math.abs(dl) > 1 && Math.abs(dl) < vw) {
        el.style.setProperty('left', Math.round((parseFloat(el.style.left) || 0) + dl) + 'px', 'important');
        fini = false;
      }
      if (fini) return;
    }
  }

  /* Header AU-DESSUS du drawer + pilule en verre CLAIR (pour ne plus laisser
     voir le sombre de la bannière). On remonte toute la CHAÎNE de la pilule
     jusqu'à #header-component (z-index) pour battre la branche du drawer, et on
     pose un fond frosted clair sur la pilule. Tout est restauré à la fermeture. */
  /* PLAQUE CLAIRE derrière le header : couvre la bande du header (entre la
     bannière et le contenu du header) pour que le dégradé noir de la bannière
     ne transparaisse PLUS à travers le verre du header. Ne touche pas la
     bannière elle-même. z : sous le contenu du header, au-dessus du reste. */
  function headerBacking(on) {
    var B = document.getElementById('fm-header-backing');
    if (!on) { if (B && B.parentNode) B.parentNode.removeChild(B); return; }
    var host = headerHost(); if (!host) return;
    var r = host.getBoundingClientRect();
    if (!B) { B = document.createElement('div'); B.id = 'fm-header-backing'; }
    B.style.cssText = 'position:fixed;left:0;right:0;' +
      'top:' + Math.round(r.top) + 'px;height:' + Math.round(r.height + 2) + 'px;' +
      'z-index:' + (HEADER_Z - 1) + ';pointer-events:none;background:#f6f4f2;';
    if (!B.parentNode) document.body.appendChild(B);
  }

  var fmRaised = [], fmStyledPill = null;
  function raiseNode(n) {
    if (!n || n.__fmh) return;
    n.__fmh = { z: n.style.zIndex, p: n.style.position };
    if (getComputedStyle(n).position === 'static') n.style.position = 'relative';
    n.style.setProperty('z-index', String(HEADER_Z), 'important');
    fmRaised.push(n);
  }
  function setHeaderAbove(apply, drawerEl) {
    if (apply) {
      var host = headerHost();
      var pill = headerBarEl(drawerEl);
      raiseNode(host);
      // remonter toute la CHAÎNE pilule -> host (pour battre la branche du drawer)
      var n = pill;
      while (n && n !== document.body) {
        if (!(drawerEl && (n === drawerEl || drawerEl.contains(n))) && !(n.closest && n.closest('.menu-drawer'))) {
          raiseNode(n);
        }
        if (n === host) break;
        n = n.parentElement;
      }
      // fond verre CLAIR sur la pilule : ne laisse plus transparaître le sombre
      if (pill && pill.__fmBg === undefined) {
        pill.__fmBg = pill.style.background;
        pill.__fmBf = pill.style.backdropFilter;
        pill.__fmWbf = pill.style.webkitBackdropFilter;
        pill.style.setProperty('background', 'rgba(248,246,244,0.80)', 'important');
        pill.style.setProperty('-webkit-backdrop-filter', 'blur(22px) saturate(150%)', 'important');
        pill.style.setProperty('backdrop-filter', 'blur(22px) saturate(150%)', 'important');
        fmStyledPill = pill;
      }
    } else {
      for (var i = 0; i < fmRaised.length; i++) {
        var m = fmRaised[i];
        if (m.__fmh) { m.style.zIndex = m.__fmh.z; if (m.__fmh.p !== undefined) m.style.position = m.__fmh.p; delete m.__fmh; }
      }
      fmRaised = [];
      if (fmStyledPill && fmStyledPill.__fmBg !== undefined) {
        fmStyledPill.style.background = fmStyledPill.__fmBg;
        fmStyledPill.style.backdropFilter = fmStyledPill.__fmBf;
        fmStyledPill.style.webkitBackdropFilter = fmStyledPill.__fmWbf;
        delete fmStyledPill.__fmBg; delete fmStyledPill.__fmBf; delete fmStyledPill.__fmWbf;
      }
      fmStyledPill = null;
    }
  }

  /* Neutraliser le voile gris (scrim) :
     1) le <dialog> parent + son ::backdrop (via la classe, en CSS)
     2) SCAN : tout élément semi-transparent SOMBRE couvrant l'écran (le voile),
        quelle que soit sa classe -> fond transparent. */
  var scrimmed = [];
  function scrim(el, on) {
    // 1) dialog parent éventuel
    var dlg = el && el.closest ? el.closest('dialog') : null;
    if (dlg) {
      if (on) {
        dlg.classList.add('fm-drawer-dialog');
        if (dlg.__fmbg === undefined) dlg.__fmbg = dlg.style.background;
        dlg.style.setProperty('background', 'transparent', 'important');
      } else {
        dlg.classList.remove('fm-drawer-dialog');
        if (dlg.__fmbg !== undefined) { dlg.style.background = dlg.__fmbg; delete dlg.__fmbg; }
      }
    }
    if (!on) {
      // restaurer les voiles neutralisés
      for (var k = 0; k < scrimmed.length; k++) {
        var nn = scrimmed[k].node;
        if (nn.__fmScrim !== undefined) { nn.style.background = nn.__fmScrim; delete nn.__fmScrim; }
        if (nn.__fmScrimBf !== undefined) { nn.style.backdropFilter = nn.__fmScrimBf; nn.style.webkitBackdropFilter = nn.__fmScrimWbf; delete nn.__fmScrimBf; delete nn.__fmScrimWbf; }
      }
      scrimmed = [];
      return;
    }
    // 2) scan des voiles : élément POSITIONNÉ, (quasi) plein écran, qui assombrit
    //    -> soit un fond semi-transparent, soit un backdrop-filter. On neutralise.
    var vw = window.innerWidth, vh = window.innerHeight;
    var nodes = document.body ? document.body.querySelectorAll('*') : [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.id === 'fm-blur-layer') continue;             // jamais ma couche de flou
      if (el && (n === el || el.contains(n))) continue;   // jamais le drawer / son contenu
      var cs = getComputedStyle(n);
      if (cs.position !== 'fixed' && cs.position !== 'absolute') continue;
      var r = n.getBoundingClientRect();
      if (r.width < vw * 0.7 || r.height < vh * 0.3) continue;   // couvre une grande zone

      var bf = cs.backdropFilter || cs.webkitBackdropFilter || '';

      // NOTE : on ne touche PLUS aux backdrop-filter brightness/contrast : c'est
      // le traitement de la bannière, pas un voile. Le header ne doit pas être
      // voilé -> on le règle en le passant AU-DESSUS (z-index), pas en cassant
      // la bannière.

      // B) autres voiles (fond semi-transparent ou blur plein écran) : on protège
      //    le header (son verre) et le tiroir.
      if (n.closest && (n.closest('#header-component') || n.closest('.menu-drawer'))) continue;

      var neutralize = false;
      var m = cs.backgroundColor && cs.backgroundColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
      if (m) {
        var a = (m[4] === undefined ? 1 : +m[4]);
        var op = parseFloat(cs.opacity); if (isNaN(op)) op = 1;
        var eff = a * op;
        if (eff > 0.02 && eff < 0.985) neutralize = true;
      }
      var hasBf = bf && bf !== 'none';
      if (hasBf) neutralize = true;

      if (neutralize) {
        if (m && n.__fmScrim === undefined) { n.__fmScrim = n.style.background; n.style.setProperty('background', 'transparent', 'important'); }
        if (hasBf && n.__fmScrimBf === undefined) {
          n.__fmScrimBf = n.style.backdropFilter; n.__fmScrimWbf = n.style.webkitBackdropFilter;
          n.style.setProperty('backdrop-filter', 'none', 'important');
          n.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
        }
        scrimmed.push({ node: n });
      }
    }
  }

  /* Recalcule la hauteur du panneau. Pendant qu'un sous-menu s'anime, on met un
     plafond GÉNÉREUX (72vh) pour ne pas rogner le déroulé ; la hauteur réelle du
     drawer suit le contenu (height auto) et croît/décroît en douceur avec le
     sous-menu. Puis, après l'anim, on resserre au contenu (snug). */
  function fitDrawer() {
    var el = drawer();
    if (!el || !wasOpen) return;
    var maxCap = Math.round(window.innerHeight * MAX_VH);
    el.style.setProperty('max-height', maxCap + 'px', 'important');   // généreux pendant l'anim
    el.__fmCap = 0;   // hauteur de repos inconnue tant que l'anim n'est pas finie :
                      // le geste retombe alors sur la hauteur mesurée (jamais une valeur périmée)
    clearTimeout(el.__fmFit);
    el.__fmFit = setTimeout(function () {
      if (!wasOpen) return;
      var open = el.querySelector('.fm-open');
      var cap = open ? maxCap : Math.min(hauteurContenu(el), maxCap);
      el.style.setProperty('max-height', cap + 'px', 'important');
      // hauteur de REPOS, relue par le geste de fermeture (wireSwipe) pour que le
      // rebond revienne exactement ici, même si le doigt arrive pendant une anim.
      el.__fmCap = cap;
    }, 480);
  }

  /* Anime la hauteur d'un sous-menu (balayage) : à l'ouverture 0 -> hauteur du
     contenu ; à la fermeture hauteur courante -> 0. */
  function animateSub(cont, open) {
    if (!cont) return;
    var sub = cont.querySelector('.menu-drawer__submenu');
    if (!sub) return;
    if (open) {
      sub.style.setProperty('max-height', sub.scrollHeight + 'px', 'important');
    } else {
      sub.style.setProperty('max-height', sub.scrollHeight + 'px', 'important'); // fige la valeur courante
      sub.getBoundingClientRect();                                               // reflow
      sub.style.setProperty('max-height', '0px', 'important');                   // -> enroulé
    }
  }

  /* Ouvre / ferme un conteneur de sous-menu EN BALAYANT DANS LES DEUX SENS.

     Le repli ne marchait pas : on retirait l'attribut `open` du <details> AVANT
     d'appeler animateSub(). Or retirer `open` rend le contenu non rendu sur le
     champ — il ne reste donc rien à animer, le sous-menu disparaît d'un coup et
     les titres du dessous remontent sèchement.

     Ici on inverse l'ordre selon le sens :
       - ouverture : on pose `open` D'ABORD (sinon scrollHeight vaut 0 et il n'y
         a aucune hauteur à viser), puis on anime ;
       - fermeture : on anime d'abord et on laisse le <details> OUVERT tout le
         temps du repli, puis on le ferme une fois la transition finie.
     Le timer est annulé si on rouvre entre-temps, sinon une fermeture en retard
     viendrait refermer un menu qu'on vient de rouvrir. */
  var SUB_MS = 440;   /* un cheveu de plus que les 0.42s de max-height sur
                         .menu-drawer__submenu — garde les deux appariés. */

  function setSub(cont, open) {
    if (!cont) return;
    clearTimeout(cont.__fmSubT);
    cont.classList.toggle('fm-open', open);
    if (open) {
      if (cont.tagName === 'DETAILS') cont.open = true;
      animateSub(cont, true);
    } else {
      animateSub(cont, false);
      cont.__fmSubT = setTimeout(function () {
        // rouvert entre-temps ? on ne touche à rien.
        if (!cont.classList.contains('fm-open') && cont.tagName === 'DETAILS') cont.open = false;
      }, SUB_MS);
    }
  }

  /* ACCORDÉON : on intercepte le clic sur les titres niveau 1 AVANT Horizon
     (phase capture + stopImmediatePropagation) et on déroule le sous-menu en
     dessous via la classe `fm-open`. */
  function wireAccordion(root) {
    var items = root.querySelectorAll('.menu-drawer__menu-item--mainlist');
    for (var i = 0; i < items.length; i++) {
      var s = items[i];
      if (s.__fmAcc) continue;
      s.__fmAcc = true;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();      // bloque le slide natif de Horizon
        var cont = this.closest('details') || this.parentElement;
        if (!cont) return;
        var willOpen = !cont.classList.contains('fm-open');
        // accordéon : referme les autres (EN BALAYAGE aussi)
        var others = root.querySelectorAll('.fm-open');
        for (var j = 0; j < others.length; j++) {
          if (others[j] !== cont) setSub(others[j], false);   // referment EN BALAYANT
        }
        setSub(cont, willOpen);          // balayage du sous-menu cliqué, dans les deux sens
        fitDrawer();
      }, true);
    }
  }

  /* Fermeture réelle du tiroir : plusieurs méthodes pour être sûr. */
  /* Fermeture DÉFINITIVE (teardown) : appelée une fois l'animation de repli finie.
     Le thème ne sait plus fermer le drawer (on l'a sorti dans <body>) : on le remet
     à sa place, on referme le <details>, on nettoie tout -> état propre ré-ouvrable. */
  function finalizeClose(el) {
    if (!el || !el.__fmPortaled) return;                 // déjà fermé
    if (el.__fmDocClick) { document.removeEventListener('click', el.__fmDocClick, true); el.__fmDocClick = null; }
    var det = el.__fmDetails || document.getElementById('Details-menu-drawer-container');
    restoreHome(el);                                     // remet le drawer dans le <details>
    if (det) { det.open = false; det.removeAttribute('open'); det.classList.remove('menu-open'); }
    var mo = document.querySelectorAll('.menu-open');
    for (var i = 0; i < mo.length; i++) mo[i].classList.remove('menu-open');
    document.documentElement.classList.remove('fm-drawer-open');
    document.documentElement.classList.remove('fm-closing');
    blocScroll(false);
    pinHeader(false);
    ['position', 'left', 'right', 'top', 'width', 'z-index', 'transition', 'max-height', 'opacity', 'overflow'].forEach(function (p) {
      el.style.removeProperty(p);
    });
    el.__fmSweeping = false;
    el.__fmCap = 0;
    wasOpen = false;
    // (holdSticky est relâché au DÉBUT du repli, dans sweepClose — pas ici.
    //  Le faire au teardown remettait le header à son état normal ~940ms après
    //  le geste, bien après que le panneau ait disparu.)
  }

  /* Fermeture par BALAYAGE bas -> haut : on fige la hauteur courante puis on la
     réduit à 0 (le haut reste sous le header, le bas remonte), PUIS teardown.
     TOUTES les fermetures (croix, hamburger, clic extérieur) passent par ici pour
     avoir la même animation que l'encoche. */
  function sweepClose(el) {
    if (!el || el.__fmSweeping) return;
    el.__fmSweeping = true;
    // Dès la première image du repli : le flou de la page part MAINTENANT, en
    // même temps que le panneau, au lieu d'attendre le teardown 560ms plus tard.
    document.documentElement.classList.add('fm-closing');
    // Et on relâche l'état « scrollé » forcé AU MÊME INSTANT. Le verre de la
    // pilule s'efface donc pendant que le panneau s'enroule, sur sa transition
    // de 0.25s, au lieu d'attendre la fin du teardown. Même instant, même
    // easing que le flou de la page : les trois partent ensemble.
    holdSticky(false);
    var h = el.getBoundingClientRect().height;
    el.style.setProperty('overflow', 'hidden', 'important');    // pas de scrollbar pendant le repli
    el.style.setProperty('transition', 'none', 'important');
    el.style.setProperty('max-height', Math.round(h) + 'px', 'important');
    el.getBoundingClientRect();                                 // reflow : fige la hauteur de départ
    /* REPLI CALÉ SUR LE HEADER (0.25s).
       Il durait 0.5s, soit le double — le header était donc déjà redevenu
       transparent alors que le bas du panneau dépassait encore sous lui.
       Deux corrections, pas une :
         - la durée revient à 0.42s : 0.5s traînait trop, 0.26s claquait. Ce
           qui compte n'est pas tant la valeur que le RAPPORT avec l'opacité
           juste en dessous ;
         - l'opacité ne traîne PLUS derrière. Elle avait 0.2s de retard à
           l'allumage et finissait après la hauteur : c'est ce décalage qui
           rendait la queue du panneau visible, puisqu'elle restait opaque
           pendant que la boîte se refermait. Elle démarre maintenant tout de
           suite et finit AVANT la hauteur (0.30 contre 0.42) : le panneau est
           déjà effacé quand la boîte achève de se replier. C'est cette avance
           qui permet d'allonger le repli sans jamais revoir la queue — tant
           qu'elle est respectée, la durée est un réglage libre. */
    el.style.setProperty('transition',
      'max-height 0.42s cubic-bezier(0.33, 0, 0.12, 1), opacity 0.30s ease', 'important');
    requestAnimationFrame(function () {
      el.style.setProperty('max-height', '0px', 'important');   // repli bas -> haut
      el.style.setProperty('opacity', '0', 'important');        // fondu vers la fin -> disparition fluide
    });
    setTimeout(function () { finalizeClose(el); }, 460);   // un peu après la fin du repli (0.42s)
  }

  /* La croix (X) du panneau -> balayage de fermeture. */
  function wireCloseButton(el) {
    var btn = el.querySelector('.menu-drawer__close-button');
    if (btn && !btn.__fmClose) {
      btn.__fmClose = true;
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); sweepClose(el); }, true);
    }
  }

  /* Le hamburger (summary) : quand le menu est OUVERT, un clic doit FERMER via le
     balayage (pas via le toggle natif du <details>, qui casse car le drawer est
     déplacé). Fermé, on laisse le thème l'ouvrir normalement. */
  function wireSummary(el) {
    var sum = document.querySelector('#Details-menu-drawer-container > summary') ||
              document.querySelector('.header__icon--summary');
    if (sum && !sum.__fmSum) {
      sum.__fmSum = true;
      sum.addEventListener('click', function (e) {
        if (wasOpen) { e.preventDefault(); e.stopImmediatePropagation(); sweepClose(el); }
      }, true);
    }
  }

  /* Clic AILLEURS que sur le drawer ou le header -> fermeture (balayage). */
  function makeDocClick(el) {
    return function (e) {
      if (!el.__fmPortaled) return;
      var t = e.target;
      if (el.contains(t)) return;                                  // dans le drawer
      if (t.closest && t.closest('#header-component')) return;     // dans le header
      sweepClose(el);
    };
  }
  /* ÉPINGLAGE DU HEADER — il fige la position RÉELLE, pas une valeur choisie.
     ----------------------------------------------------------------------
     En `sticky`, le header se résout contre le scrollport le plus proche, et
     n'importe quel ancêtre qui passe en overflow non-visible le lui vole : on
     a vu le header décrocher de trois façons différentes à cause de ça. En
     `fixed`, il se cale sur le viewport, hors d'atteinte.

     Mais il ne faut surtout pas l'épingler à `top: 0` : .header-section n'est
     pas en haut de l'écran, elle est SOUS la barre d'annonce (53px en haut de
     page). L'y coller remontait le header d'autant. Et une constante serait
     fausse dans l'autre cas, puisque page scrollée le sticky l'a déjà amenée
     à ~0.

     On lit donc sa position courante et on la fige là. C'est juste dans les
     deux cas, et sans risque de décalage : le défilement est verrouillé le
     temps de l'ouverture, cette position ne peut pas devenir obsolète.
     .header-section est mesurée à une hauteur de 0 (header transparent posé en
     surimpression), donc la sortir du flux ne déplace rien non plus. */
  function pinHeader(on) {
    var sec = document.querySelector('.header-section');
    if (!sec) return;
    if (on) {
      if (sec.__fmPin) return;
      var t = Math.round(sec.getBoundingClientRect().top);
      sec.__fmPinPrev = sec.getAttribute('style') || '';
      sec.__fmPin = true;
      sec.style.setProperty('position', 'fixed', 'important');
      sec.style.setProperty('top', t + 'px', 'important');
      sec.style.setProperty('left', '0', 'important');
      sec.style.setProperty('right', '0', 'important');
      // pas de z-index ici : celui de la règle sticky du thème s'applique déjà
    } else {
      if (!sec.__fmPin) return;
      sec.__fmPin = false;
      // on restaure l'attribut style tel qu'il était, plutôt que de retirer les
      // propriétés une à une : ça ne laisse aucun résidu.
      if (sec.__fmPinPrev) sec.setAttribute('style', sec.__fmPinPrev);
      else sec.removeAttribute('style');
    }
  }

  /* VERROU DE DÉFILEMENT SANS CLIP.
     ----------------------------------------------------------------------
     On ne peut plus compter sur `overflow: hidden` à la racine : sur iOS il
     clippe le rendu à la fenêtre de mise en page, ce qui découvre la zone de
     la barre Safari (98pt de blanc, mesurés) et fait décrocher le header
     sticky. On bloque donc le geste plutôt que la boîte.

     Le `touchmove` est intercepté en NON PASSIF — c'est la condition pour que
     preventDefault() ait le moindre effet — et en CAPTURE, pour qu'aucun
     gestionnaire intermédiaire ne puisse l'avaler avant nous. On laisse passer
     tout geste né dans le tiroir, sinon on verrouillerait aussi le menu.
     Ce blocage vient EN PLUS du `overflow: hidden` posé sur <html> par le CSS :
     iOS applique ce dernier de façon inégale selon la version. */
  function stopScroll(e) {
    var t = e.target;
    // On laisse passer TOUT geste né dans le tiroir, pas seulement dans
    // .fm-scroll : viser .fm-scroll était trop étroit et bloquait le
    // défilement du menu. Le tiroir gère ses propres gestes (défilement
    // interne, glissement de fermeture) ; on ne verrouille que la page.
    if (t && t.closest && t.closest('.menu-drawer, [ref="menuDrawer"]')) return;
    if (e.cancelable) e.preventDefault();
  }

  function blocScroll(on) {
    if (on) {
      if (blocScroll.__pose) return;
      blocScroll.__pose = true;
      document.addEventListener('touchmove', stopScroll, { passive: false, capture: true });
    } else {
      if (!blocScroll.__pose) return;
      blocScroll.__pose = false;
      document.removeEventListener('touchmove', stopScroll, { passive: false, capture: true });
    }
  }

  /* ZONE DÉFILANTE INTERNE — c'est elle qui rend le fondu temps réel.
     ----------------------------------------------------------------------
     Avant, le panneau était à la fois le porteur du verre ET l'élément qui
     défile. Impossible d'y poser le fondu : un masque sur lui aurait dissous
     le verre, la bordure et les coins avec le texte. Et un masque sur la LISTE
     défile avec le contenu, d'où les recalages en JS qui arrivaient en retard
     sur iOS.

     On sépare donc les deux rôles. Le panneau garde le verre et passe en
     overflow: hidden ; un conteneur interne prend le défilement. Son encadré
     ne bouge jamais, et un masque posé dessus reste donc collé au bas de la
     fenêtre — peint par le navigateur, sans une ligne de JS, donc sans aucun
     retard possible, inertie comprise.

     L'encoche et la croix restent DEHORS : rien ne peut passer derrière elles,
     et elles ne sont jamais touchées par le masque. */
  function ensureScroll(el) {
    var sc = el.querySelector('.fm-scroll');
    if (sc && sc.parentNode === el) return sc;
    sc = document.createElement('div');
    sc.className = 'fm-scroll';
    var aDeplacer = [];
    for (var i = 0; i < el.children.length; i++) {
      var c = el.children[i];
      if (c.classList.contains('fm-handle')) continue;              // l'encoche reste dehors
      if (c.classList.contains('menu-drawer__close-button')) continue;  // la croix aussi
      aDeplacer.push(c);
    }
    el.insertBefore(sc, el.firstChild);
    for (var j = 0; j < aDeplacer.length; j++) sc.appendChild(aDeplacer[j]);
    return sc;
  }

  /* Hauteur NATURELLE du contenu. On ne peut plus lire el.scrollHeight : le
     panneau ne déborde plus (overflow: hidden) et la zone interne est
     contrainte par le flex, donc les deux renvoient la hauteur visible. On
     additionne donc la hauteur réelle du contenu défilant, l'encoche avec sa
     marge, et les paddings du panneau. */
  function hauteurContenu(el) {
    var sc = el.querySelector('.fm-scroll');
    var h = el.querySelector('.fm-handle');
    var cs = getComputedStyle(el);
    var pads = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var hEnc = 0;
    if (h) {
      var ch = getComputedStyle(h);
      hEnc = h.getBoundingClientRect().height + (parseFloat(ch.marginTop) || 0);
    }
    return Math.ceil((sc ? sc.scrollHeight : el.scrollHeight) + hEnc + pads + 6);
  }

  /* ENCOCHE : on l'ajoute dans le panneau (une seule fois — le tiroir est remis
     dans son <details> à la fermeture, donc l'élément survit d'une ouverture à
     l'autre, et querySelector évite le doublon). */
  function ensureHandle(el) {
    var h = el.querySelector('.fm-handle');
    if (!h) { h = document.createElement('div'); h.className = 'fm-handle'; el.appendChild(h); }
    return h;
  }

  /* GESTE : tenir et remonter -> le panneau RÉTRÉCIT PAR LE BAS (le haut reste
     collé au header, il ne dépasse JAMAIS le header). Assez remonté = fermeture ;
     sinon rebond à la hauteur de repos.

     Calqué sur le tiroir des recommandations du panier (sidecart.js), qui se
     manipule beaucoup mieux. Ce que la version précédente n'avait pas :

       1. elle n'écoutait que sur l'encoche, 26 px de haut. Ici on écoute sur TOUT
          le panneau : l'encoche reste la zone sûre (elle glisse toujours), mais on
          peut aussi attraper le panneau n'importe où.
       2. elle engageait le glissement dès le touchstart. Ici il faut 8 px de
          mouvement, et on abandonne si le geste est horizontal (|dx| > |dy|) ou
          dirigé vers le bas depuis le repos : un simple appui ne déforme plus rien.
       3. elle coupait la transition au contact, même pour un appui sans glissement.
          Ici on ne la coupe qu'une fois le geste réellement engagé.
       4. elle n'avait aucune garde de défilement : partir d'une zone défilable
          volait le scroll du contenu. Ici, hors encoche, on n'engage que si le
          contenu est déjà en bas (plus rien à faire défiler vers le haut).
       5. elle laissait passer le clic : finir le geste sur un lien naviguait. Ici
          le clic est neutralisé 400 ms après un vrai glissement.
       6. elle ne gérait que le tactile, alors que l'encoche affiche `cursor: grab`.
          Ici la souris marche aussi, via les événements pointer et la capture.
       7. elle mesurait la hauteur de départ au contact : attraper le panneau
          pendant l'animation d'ouverture donnait un rebond vers une hauteur
          fausse. Ici on part de `__fmCap`, la hauteur de repos posée par
          fitDrawer(), et la mesure n'est qu'un filet de sécurité. */
  var ENGAGE_PX = 8;     // mouvement minimum avant d'engager le glissement
  var CLOSE_PX = 48;     // remontée suffisante pour fermer (seuil du sidecart)
  var RUBBER = 0.18;     // résistance quand on tire vers le bas

  function wireSwipe(el) {
    ensureHandle(el);
    if (el.__fmDrag) return;
    el.__fmDrag = true;

    var drag = null;             // { y, startH, active }
    var suppressClickUntil = 0;

    /* Hauteur de repos : celle que fitDrawer() a posée, sinon la hauteur peinte. */
    function restHeight() {
      var cap = el.__fmCap;
      if (typeof cap === 'number' && cap > 0) return cap;
      return el.getBoundingClientRect().height;
    }

    /* Y a-t-il encore du contenu à faire défiler vers le haut sous le doigt ?
       Si oui, le geste appartient au défilement, pas à la fermeture. */
    function peutDefiler(node) {
      var n = node;
      while (n && n !== el.parentNode) {
        if (n.nodeType === 1 && n.scrollHeight - n.clientHeight > 2) {
          if (n.scrollTop < n.scrollHeight - n.clientHeight - 2) return true;
        }
        n = n.parentNode;
      }
      return false;
    }

    /* Deux portes d'entrée :
         - l'ENCOCHE : elle glisse toujours, sans condition. C'est la zone sûre.
         - le reste du panneau : seulement si on ne part pas d'un élément
           interactif, et seulement s'il ne reste rien à faire défiler vers le
           haut — sinon le geste appartient au défilement, pas à la fermeture. */
    function startDrag(y, target) {
      var surEncoche = !!(target.closest && target.closest('.fm-handle'));
      if (!surEncoche) {
        if (target.closest && target.closest('a, button, summary, input, select, textarea')) return;
        if (peutDefiler(target)) return;
      }
      drag = { y: y, startH: restHeight(), active: false };
    }

    function moveDrag(x, y, event, x0) {
      if (!drag) return;
      var dy = y - drag.y;
      var dx = x - x0;
      if (!drag.active) {
        if (Math.abs(dx) < ENGAGE_PX && Math.abs(dy) < ENGAGE_PX) return;
        // on ne ferme qu'en REMONTANT ; horizontal ou vers le bas -> on rend la main
        if (dy >= 0 || Math.abs(dx) > Math.abs(dy)) { drag = null; return; }
        drag.active = true;
        el.classList.add('fm-dragging');
        el.style.setProperty('transition', 'none', 'important');
        el.style.setProperty('overflow', 'hidden', 'important'); // pas de scrollbar pendant le geste
      }
      if (event.cancelable) event.preventDefault();
      drag.dy = dy;
      var h = drag.startH + dy;                                  // dy < 0 -> rétrécit
      if (h < 0) h = 0;
      if (h > drag.startH) h = drag.startH + (h - drag.startH) * RUBBER;
      el.style.setProperty('max-height', Math.round(h) + 'px', 'important');
    }

    function finishDrag() {
      if (drag && drag.active) {
        suppressClickUntil = Date.now() + 400;
        var dy = drag.dy || 0;
        el.classList.remove('fm-dragging');
        if (-dy >= CLOSE_PX) { drag = null; sweepClose(el); return; }
        // rebond à la hauteur de repos
        el.style.setProperty('transition', 'max-height 0.32s cubic-bezier(0.22, 0.61, 0.36, 1)', 'important');
        el.style.setProperty('max-height', Math.round(drag.startH) + 'px', 'important');
        setTimeout(function () {
          el.style.removeProperty('transition');
          el.style.removeProperty('overflow');
        }, 340);
      }
      cancelDrag();
    }

    function cancelDrag() {
      if (el.classList.contains('fm-dragging')) el.classList.remove('fm-dragging');
      drag = null;
    }

    /* ---- tactile ---- */
    var t0x = 0;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return cancelDrag();
      t0x = e.touches[0].clientX;
      startDrag(e.touches[0].clientY, e.target);
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return cancelDrag();
      moveDrag(e.touches[0].clientX, e.touches[0].clientY, e, t0x);
    }, { passive: false });

    el.addEventListener('touchend', finishDrag);
    el.addEventListener('touchcancel', cancelDrag);

    /* ---- souris : mêmes règles que le doigt, depuis le panneau ---- */
    var m0x = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      m0x = e.clientX;
      startDrag(e.clientY, e.target);
    });

    el.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !drag) return;
      moveDrag(e.clientX, e.clientY, e, m0x);
      if (drag && drag.active && !el.hasPointerCapture(e.pointerId)) el.setPointerCapture(e.pointerId);
    });

    el.addEventListener('pointerup', function (e) {
      if (e.pointerType !== 'mouse') return;
      finishDrag();
      if (el.hasPointerCapture(e.pointerId)) el.releasePointerCapture(e.pointerId);
    });

    el.addEventListener('pointercancel', cancelDrag);

    /* Un glissement qui se termine sur un lien ne doit pas naviguer. */
    el.addEventListener('click', function (e) {
      if (Date.now() >= suppressClickUntil) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  }

  /* COUCHE DE FLOU derrière le drawer : un calque plein écran dans <body>
     (hors du header) pour que backdrop-filter fonctionne vraiment (le tiroir
     imbriqué dans le header au filtre déjà appliqué ne peut pas flouter). */
  function blurLayer(on) {
    var L = document.getElementById('fm-blur-layer');
    if (!on) { if (L && L.parentNode) L.parentNode.removeChild(L); return; }
    if (!L) { L = document.createElement('div'); L.id = 'fm-blur-layer'; }
    L.style.cssText = 'position:fixed;z-index:' + (DRAWER_Z - 1) + ';pointer-events:none;' +
      'border-radius:48px 48px 74px 74px;' +
      '-webkit-backdrop-filter:blur(16px) saturate(120%);backdrop-filter:blur(16px) saturate(120%);' +
      'background:rgba(0,0,0,0);';
    if (!L.parentNode) document.body.appendChild(L);
    sizeBlur();
  }
  /* dimensionne la couche exactement sur le rectangle du drawer */
  function sizeBlur() {
    var L = document.getElementById('fm-blur-layer'); if (!L) return;
    var el = drawer(); if (!el) return;
    var r = el.getBoundingClientRect();
    var h = Math.min(hauteurContenu(el), Math.round(window.innerHeight * MAX_VH));
    L.style.left = Math.round(r.left) + 'px';
    L.style.top = Math.round(r.top) + 'px';
    L.style.width = Math.round(r.width) + 'px';
    L.style.height = Math.round(h) + 'px';
  }
  function updateBlurTransform(dy) {
    var L = document.getElementById('fm-blur-layer');
    if (L) L.style.transform = 'translateY(' + Math.min(0, dy) + 'px)';
  }

  function onOpen(el) {
    if (!isMobile()) return;
    /* LA CLASSE EN PREMIER, avant tout le reste.
       ------------------------------------------------------------------
       Elle ne sert pas qu'à montrer le panneau : c'est elle qui active
       `html.fm-drawer-open .page-wrapper { overflow: visible }`, la contre-mesure
       au `scroll-lock` de Pitch. Or le thème pose cet attribut ~2ms après le
       clic, alors que la classe arrivait dans un double requestAnimationFrame,
       soit ~66ms plus tard (mesuré sur la preview). Pendant ces trois frames,
       .page-wrapper était clippé sans protection, il volait le scrollport du
       header sticky, et celui-ci décrochait à sa position statique — hors écran
       si la page était scrollée. Que le header se re-colle ensuite ou non
       dépend du navigateur : d'où un bug intermittent.

       La poser ici ne découvre rien trop tôt : `max-height: 0px` est appliqué
       en style INLINE quelques lignes plus bas, et un inline !important bat la
       feuille de style. Le panneau reste donc fermé jusqu'au rAF qui lance
       l'animation. */
    document.documentElement.classList.add('fm-drawer-open');
    blocScroll(true);
    wireAccordion(el);
    ensureScroll(el);   // doit passer AVANT wireSwipe : lui pose l'encoche, qui doit rester hors du conteneur
    wireSwipe(el);
    wireCloseButton(el);
    wireSummary(el);
    holdSticky(true);           // force l'état scroll -> le thème applique le verre du header
    pinHeader(true);            // fige sa position courante : plus aucun ancêtre ne peut le faire décrocher
    portalToBody(el);           // SORT le panneau dans <body> -> il peut passer DERRIÈRE le header
    el.style.setProperty('z-index', String(DRAWER_BODY_Z), 'important');  // sous la section header (18)
    el.style.setProperty('max-height', '0px', 'important');
    positionUnderHeader(el);
    el.getBoundingClientRect(); // reflow au repos (0px)
    // clic extérieur = fermeture (ajouté au tick suivant pour ne PAS capter le clic
    // d'ouverture lui-même).
    if (!el.__fmDocClick) {
      el.__fmDocClick = makeDocClick(el);
      setTimeout(function () { if (el.__fmDocClick) document.addEventListener('click', el.__fmDocClick, true); }, 0);
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        // (la classe est posée tout en haut de onOpen, voir le commentaire)
        positionUnderHeader(el);   // re-cale après rendu
        var cap = Math.min(hauteurContenu(el), Math.round(window.innerHeight * MAX_VH));
        el.__fmCap = cap;
        el.style.setProperty('max-height', cap + 'px', 'important');
      });
    });
  }

  var wasOpen = false;
  function check() {
    var el = drawer();
    if (!el) return;
    if (el.__fmPortaled) return;    // ouvert : la fermeture est gérée par sweepClose/finalizeClose
    var open = isOpen(el);
    if (open && !wasOpen && isMobile()) { wasOpen = true; onOpen(el); }
    else if (!open && wasOpen) {
      wasOpen = false;
      // FILET DE SÉCURITÉ. Le relâchement normal se fait dans finalizeClose(),
      // mais on n'y passe que par sweepClose(). Si le tiroir se ferme par une
      // autre voie — le thème qui reprend la main, ou une exception quelque part
      // entre l'ouverture et le teardown — le verrou resterait posé. Et un
      // verrou oublié, c'est une page qu'on ne peut plus faire défiler du tout :
      // la barre de Safari ne se rétracte alors JAMAIS, puisque seul le geste de
      // l'utilisateur la rétracte. blocScroll est idempotent, l'appeler ici ne
      // coûte rien.
      blocScroll(false);
      pinHeader(false);
      document.documentElement.classList.remove('fm-closing');
    }
  }

  function init() {
    check();
    var mo = new MutationObserver(function () {
      if (mo.__t) return;
      mo.__t = requestAnimationFrame(function () { mo.__t = 0; check(); });
    });
    mo.observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['open', 'aria-hidden', 'aria-expanded', 'data-state', 'class', 'style']
    });
    window.addEventListener('resize', function () {
      if (wasOpen) positionUnderHeader(drawer());
    }, { passive: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();